// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.res-custom-calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
  bottom: 0;
  left: 0%;
  background-color: #ffffff00;
  border-radius: 0.5rem;
}

.res-calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 18px;  /* changed 4*/
  width: auto;
}

.res-calendar-day {
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0000003a;
  cursor: pointer;
  position: relative;
  margin: 3px;
  padding: 12px;
  font-size: 20px;
  color: #010a0c;
}

.res-calendar-day::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}

.res-calendar-day span {
  display: inline-block;
  vertical-align: middle;
  z-index: 1;
}

.res-calendar-day:not(.placeholder) {
  border-color: #000405;
}

.res-days-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 500px;
  margin-left: 20px;
  color: #ffffff;
  padding-top: 8px;
  padding-bottom: 8px;
}

.res-day {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: 2px solid #ffffff;
  background-color: #47c2bc65;
  padding: 1px;
}

.res-calendar-navigation-container {
  display: flex;
  bottom: 0;
  width: 100%;  
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

}

.res-calendar-header {
  white-space: nowrap;
  font-size: 20px;
  margin-left: 40px;
  margin-right: 40px;
margin-top: 45px;
}

.res-navigation-icon {
  font-size: 14px;
  width: 35px;
  height: 35px;
  border: 1px solid transparent;
  border-radius: 50%;
  border-color: #757575;
  transition: background-color 0.3s ease-in-out;
  color: #757575;
  margin: 8px;
}

.res-navigation-icon:hover {
  background-color: rgba(71, 194, 187, 0.12);
  border-color: #5A9BD8;
  color: #5A9BD8;
}

.res-navigation-icon.selected {
  color: #5A9BD8;
  border: 1px solid rgba(71, 194, 188, 0.349);
  background-color: rgba(71, 194, 187, 0.12);
}

.res-navigation-icon.selected:hover {
  border-color: #5A9BD8;
  color: #5A9BD8;
  background-color: #5A9BD8;
}

.res-calendar-day {
  position: relative;
}

.res-calendar-day.unavailable {
  background-color: rgb(248, 2, 2);
  color: white;
}

.res-calendar-day.unavailable:hover::after {
  content: "Holiday";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  padding: 1px;
  padding-top: 11px;
  padding-bottom: 11px;
  background-color: rgb(248, 2, 2);
  color: #fff;
  white-space: nowrap;
  font-size: 12px;
}


.res-calendar-day.available {
  background-color: #81e6d373; 
  color: #000; 
}

.res-calendar-day.current-date {
  background-color: rgb(1, 117, 126);
  color: #fff;
}

.res-calendar-day.current-date:hover::after {
  content: "Today";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  padding: 1px;
  padding-top: 11px;
  padding-bottom: 11px;
  background-color: rgb(1, 117, 126);
  color: #fff;
  white-space: nowrap;
  font-size: 12px;
}

.res-calendar-day.selected {
  background-color: #00000027!important;
  color: #fff;
}

.res-calendar-day.selectedDates {
  background-color: #00000023;
  color: #fff;
}


.res-calendar-day.available.selected {
  background-color: rgba(0, 0, 0, 0.1);
  color: #000;
}

.res-cal-date {
  background-color: #67d9c4e3 !important;
  color: white !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Resource/ResourceCalander.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS,GAAG,aAAa;EACzB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;;AAErB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB,gBAAgB;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;EACd,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;;AAGA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;;AAGA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;AACzB","sourcesContent":[".res-custom-calendar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  bottom: 0;\r\n  left: 0%;\r\n  background-color: #ffffff00;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.res-calendar-days {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 18px;  /* changed 4*/\r\n  width: auto;\r\n}\r\n\r\n.res-calendar-day {\r\n  width: calc(100% - 10px);\r\n  height: calc(100% - 10px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid #0000003a;\r\n  cursor: pointer;\r\n  position: relative;\r\n  margin: 3px;\r\n  padding: 12px;\r\n  font-size: 20px;\r\n  color: #010a0c;\r\n}\r\n\r\n.res-calendar-day::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  height: 100%;\r\n}\r\n\r\n.res-calendar-day span {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  z-index: 1;\r\n}\r\n\r\n.res-calendar-day:not(.placeholder) {\r\n  border-color: #000405;\r\n}\r\n\r\n.res-days-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  width: 500px;\r\n  margin-left: 20px;\r\n  color: #ffffff;\r\n  padding-top: 8px;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.res-day {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  border: 2px solid #ffffff;\r\n  background-color: #47c2bc65;\r\n  padding: 1px;\r\n}\r\n\r\n.res-calendar-navigation-container {\r\n  display: flex;\r\n  bottom: 0;\r\n  width: 100%;  \r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n\r\n}\r\n\r\n.res-calendar-header {\r\n  white-space: nowrap;\r\n  font-size: 20px;\r\n  margin-left: 40px;\r\n  margin-right: 40px;\r\nmargin-top: 45px;\r\n}\r\n\r\n.res-navigation-icon {\r\n  font-size: 14px;\r\n  width: 35px;\r\n  height: 35px;\r\n  border: 1px solid transparent;\r\n  border-radius: 50%;\r\n  border-color: #757575;\r\n  transition: background-color 0.3s ease-in-out;\r\n  color: #757575;\r\n  margin: 8px;\r\n}\r\n\r\n.res-navigation-icon:hover {\r\n  background-color: rgba(71, 194, 187, 0.12);\r\n  border-color: #5A9BD8;\r\n  color: #5A9BD8;\r\n}\r\n\r\n.res-navigation-icon.selected {\r\n  color: #5A9BD8;\r\n  border: 1px solid rgba(71, 194, 188, 0.349);\r\n  background-color: rgba(71, 194, 187, 0.12);\r\n}\r\n\r\n.res-navigation-icon.selected:hover {\r\n  border-color: #5A9BD8;\r\n  color: #5A9BD8;\r\n  background-color: #5A9BD8;\r\n}\r\n\r\n.res-calendar-day {\r\n  position: relative;\r\n}\r\n\r\n.res-calendar-day.unavailable {\r\n  background-color: rgb(248, 2, 2);\r\n  color: white;\r\n}\r\n\r\n.res-calendar-day.unavailable:hover::after {\r\n  content: \"Holiday\";\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 1px;\r\n  padding-top: 11px;\r\n  padding-bottom: 11px;\r\n  background-color: rgb(248, 2, 2);\r\n  color: #fff;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n}\r\n\r\n\r\n.res-calendar-day.available {\r\n  background-color: #81e6d373; \r\n  color: #000; \r\n}\r\n\r\n.res-calendar-day.current-date {\r\n  background-color: rgb(1, 117, 126);\r\n  color: #fff;\r\n}\r\n\r\n.res-calendar-day.current-date:hover::after {\r\n  content: \"Today\";\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 1px;\r\n  padding-top: 11px;\r\n  padding-bottom: 11px;\r\n  background-color: rgb(1, 117, 126);\r\n  color: #fff;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n}\r\n\r\n.res-calendar-day.selected {\r\n  background-color: #00000027!important;\r\n  color: #fff;\r\n}\r\n\r\n.res-calendar-day.selectedDates {\r\n  background-color: #00000023;\r\n  color: #fff;\r\n}\r\n\r\n\r\n.res-calendar-day.available.selected {\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n  color: #000;\r\n}\r\n\r\n.res-cal-date {\r\n  background-color: #67d9c4e3 !important;\r\n  color: white !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
